import { render, staticRenderFns } from "./dialog-insertrelation.vue?vue&type=template&id=4a5a1ff7&"
import script from "./dialog-insertrelation.vue?vue&type=script&lang=js&"
export * from "./dialog-insertrelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports